export default "__VITE_ASSET__DOSN1osX__"